<template>
  <div 
    class="command-palette-item" :class="{ 'is-active': active, 'has-separator': separator}"
    @click="$emit('select')"
    @mouseenter="$emit('mouseenter')"
  >
    <div class="item-icon" v-if="icon">
      <i :class="icon"></i>
    </div>
    <div class="item-content">
      <div class="item-title">{{ title }}</div>
      <div v-if="subtitle" class="item-subtitle">{{ subtitle }}</div>
    </div>
    <div class="item-accessories">
      <slot name="accessories">
        <kbd v-if="shortcut" class="command-palette-kbd">{{ shortcut }}</kbd>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommandPaletteListItem',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    shortcut: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    separator: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select', 'mouseenter']
}
</script>

<style lang="scss" scoped>
.command-palette-item {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover, &.is-active {
    background-color: var(--ld-bg-primary);
  }
  border-left: 2px solid transparent;

  &.is-active {
    border-left: 2px solid var(--ld-brand-primary);
  }

  &.has-separator {
    border-top: 1px solid var(--ld-border-default);
  }

  .item-icon {
    margin-right: 12px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--ld-text-primary);
  }
  
  .item-content {
    flex: 1;
    
    .item-title {
      font-size: 14px;
    }
    
    .item-subtitle {
      font-size: 12px;
      color: var(--ld-text-secondary);
    }
  }

  .item-accessories {
    .command-palette-kbd {
      background: var(--ld-bg-primary);
      border-radius: 4px;
      padding: 2px 6px;
      font-size: 12px;
      font-family: monospace;
      color: var(--ld-text-primary);
    }
  }
}
</style> 